import { Controller } from "stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["providerSelect", "voiceSelect", "modelInput"];

  connect() {
    this.syncOptions();
    this.startPolling();
  }

  disconnect() {
    this.stopPolling();
  }

  syncOptions() {
    if (!this.hasProviderSelectTarget || !this.hasVoiceSelectTarget || !this.hasModelInputTarget) return;

    const providerOptions = this.providerOptions();
    const provider = this.providerSelectTarget.value;
    const config = providerOptions[provider] || { model: "", voices: [] };

    this.modelInputTarget.value = config.model || "";

    const currentValue = this.voiceSelectTarget.value;
    this.voiceSelectTarget.innerHTML = "";

    (config.voices || []).forEach((voice) => {
      const option = document.createElement("option");
      const value = Array.isArray(voice) ? voice[1] : voice;
      const label = Array.isArray(voice) ? voice[0] : voice;
      option.value = value;
      option.textContent = label;
      if (value === currentValue) option.selected = true;
      this.voiceSelectTarget.appendChild(option);
    });

    const voiceValues = (config.voices || []).map((voice) => Array.isArray(voice) ? voice[1] : voice);
    if (!voiceValues.includes(currentValue)) {
      this.voiceSelectTarget.selectedIndex = 0;
    }
  }

  async poll() {
    const pollUrl = this.element.dataset.articleAudioPanelAudioStatusUrl;
    if (!pollUrl) return;

    const requestUrl = new URL(pollUrl, window.location.origin);
    requestUrl.searchParams.set("_ts", Date.now().toString());

    try {
      const response = await fetch(requestUrl.toString(), {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        },
        cache: "no-store",
        credentials: "same-origin"
      });

      if (!response.ok) return;

      const responseText = await response.text();
      if (responseText) Turbo.renderStreamMessage(responseText);
    } catch (_error) {
    }
  }

  startPolling() {
    if (this.element.dataset.articleAudioPanelPollingEnabled !== "true") return;

    this.stopPolling();
    this.poll();

    const interval = Number(this.element.dataset.articleAudioPanelPollingInterval || 5000);
    this.pollingTimer = setInterval(() => this.poll(), interval);
  }

  stopPolling() {
    if (!this.pollingTimer) return;

    clearInterval(this.pollingTimer);
    this.pollingTimer = null;
  }

  providerOptions() {
    if (!this.hasProviderSelectTarget) return {};

    try {
      return JSON.parse(this.providerSelectTarget.dataset.providerOptions || "{}");
    } catch (_error) {
      return {};
    }
  }
}
